import { render, staticRenderFns } from "./WxOpenLaunchWeapp.vue?vue&type=template&id=d3bc408e&scoped=true&"
import script from "./WxOpenLaunchWeapp.vue?vue&type=script&lang=js&"
export * from "./WxOpenLaunchWeapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bc408e",
  null
  
)

export default component.exports